import type { CourseChatMessage } from "services/courseChatService";
import type { ApiEnvelope } from "services/apiTypes";

export function normalizeChatMessage(envelope: ApiEnvelope<unknown> | undefined): CourseChatMessage | null {
  const payload = envelope?.result;
  if (payload == null) return null;

  if (typeof payload === "object" && payload !== null && "data" in payload) {
    const nested = (payload as { data?: CourseChatMessage }).data;
    if (nested && typeof nested === "object" && "id" in nested) {
      return nested;
    }
  }

  if (typeof payload === "object" && payload !== null && "id" in payload) {
    return payload as CourseChatMessage;
  }

  return null;
}
